module.exports = __webpack_public_path__ + "static/media/logo_lg.22880cc6.png";